export const transformDataHelper = (batchConfiguration) => {
  const transformedData = [];

  Object.keys(batchConfiguration || {}).map((key) => {
    if (!['is_batch_number_editable', 'restriction'].includes(key)) {
      const fieldName = key.split('_is_')[0];
      const keyName = key.split('_is_')[1];
      const fieldInfo = {
        field_name: fieldName,
        [keyName]: batchConfiguration[key],
      };

      const existingFieldIndex = transformedData.findIndex((item) => item.field_name === fieldName);

      if (existingFieldIndex !== -1) {
        transformedData[existingFieldIndex][keyName] = batchConfiguration[key];
      } else {
        transformedData.push(fieldInfo);
      }
    }
  });

  return transformedData.map((data) => {
    data.field_name = data.field_name.replaceAll('_', ' ');
    data.field_name = data.field_name.toProperCase();
    return data;
  });
};

export const setConfigurationValueHelper = (labelConfiguration, value, keyName) => {
  let newLabelConfiguration = JSON.parse(JSON.stringify(labelConfiguration));
  newLabelConfiguration = newLabelConfiguration?.map((data) => {
    if (data?.key_name === keyName) {
      return {
        ...data, value,
      };
    }
    return { ...data };
  });
  return newLabelConfiguration;
};
